import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import qs from 'qs';

export function useUpdateLocationFromFilter<TFilter = Record<string, unknown>>(
  filter: Partial<TFilter> = {}
) {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (filter && Object.keys(filter).length > 0) {
      const queryStr = qs.stringify(filter, {
        arrayFormat: 'brackets',
        encode: false,
      });
      if (queryStr) {
        history.replace(location.pathname + '?' + queryStr);
      } else {
        history.replace(location.pathname);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(filter)]);
}
